// Studio's binding of the engine's shared Studio-API persistence: it supplies
// the authenticated transport, the engine owns the semantics (autosave slots,
// non-prop round-trip, snapshots). See
// engine/editor/persistence/studioApiPersistence.ts.
import type { CharacterPose, PosePersistence, PosePersistenceResult } from '../../engine';
import { createStudioApiPersistence } from '../../engine';
import { apiGet, apiPost, apiPut } from '../services/api';

export const buildKitMapPersistence = createStudioApiPersistence({
  get: (path) => apiGet(path),
  put: (path, body, opts) => apiPut(path, body, opts),
  post: (path, body) => apiPost(path, body),
});

export const buildKitPosePersistence: PosePersistence = {
  async loadPoses(projectId: string): Promise<PosePersistenceResult> {
    const poses = await apiGet<CharacterPose[]>(`/projects/${projectId}/characters/poses`);
    return { poses };
  },

  async savePoses(projectId: string, poses: CharacterPose[]): Promise<PosePersistenceResult> {
    // Upsert poses into backend
    const payload = poses.map((pose) => ({
      id: pose.id,
      name: pose.name,
      rigId: pose.rigId,
      boneTransforms: pose.boneTransforms,
    }));
    await apiPost(`/projects/${projectId}/characters/poses`, { poses: payload });
    return { poses };
  },
};
